import { i18n } from "../../translate/i18n";

const CREDENTIAL_CHANNELS = new Set(["whatsappcloud", "facebook", "telegram", "email"]);

export function getConnectionWizardSteps(channel) {
	const steps = [
		{
			id: "basic",
			label: i18n.t("connections.wizard.steps.basic"),
		},
	];

	if (CREDENTIAL_CHANNELS.has(channel)) {
		steps.push({
			id: "credentials",
			label: i18n.t("connections.wizard.steps.credentials"),
		});
	}

	if (channel !== "email") {
		steps.push({
			id: "messages",
			label: i18n.t("connections.wizard.steps.messages"),
		});
	}

	steps.push({
		id: "queues",
		label: i18n.t("connections.wizard.steps.queues"),
	});

	return steps;
}

export const HUB_WIZARD_STEPS = [
	{
		id: "channel",
		label: i18n.t("connections.wizard.steps.hubChannel"),
	},
	{
		id: "details",
		label: i18n.t("connections.wizard.steps.hubDetails"),
	},
];
